import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";
import { get } from "src/utils/networkUtils";

export default function RuleTypeRules(props) {
  const getInitialRuleData = () => {
    const defaultData = {
      rewardAmount: "",
      rewardType: "coins",
      minSpending: "",
      marketplaceItemId: "",
      requiredDays: "",
      packTypes: [],
    };

    if (props.rules) {
      try {
        const parsedRules =
          typeof props.rules === "string"
            ? JSON.parse(props.rules)
            : props.rules;
        return {
          ...defaultData,
          ...parsedRules,
        };
      } catch (error) {
        console.error("Error parsing rules:", error);
        return defaultData;
      }
    }

    return defaultData;
  };

  const [ruleData, setRuleData] = useState(getInitialRuleData());

  const [storeItems, setStoreItems] = useState([]);
  const [packTypes, setPackTypes] = useState([]);

  useEffect(() => {
    const getInitialData = () => {
      const defaultData = {
        rewardAmount: "",
        rewardType: "coins",
        minSpending: "",
        marketplaceItemId: "",
        requiredDays: "",
        packTypes: [],
      };

      if (props.rules) {
        try {
          const parsedRules =
            typeof props.rules === "string"
              ? JSON.parse(props.rules)
              : props.rules;
          return {
            ...defaultData,
            ...parsedRules,
          };
        } catch (error) {
          console.error("Error parsing rules:", error);
          return defaultData;
        }
      }

      return defaultData;
    };

    setRuleData(getInitialData());
  }, [props.ruleType, props.rules]);

  useEffect(() => {
    get("/admin/marketplace/store-items")
      .then(function (response) {
        setStoreItems(response.items || []);
      })
      .catch(function (error) {
        console.error("Error fetching store items:", error);
        setStoreItems([]);
      });

    get("/admin/packs/types")
      .then(function (response) {
        setPackTypes(response.packTypes || []);
      })
      .catch(function (error) {
        console.error("Error fetching pack types:", error);
        setPackTypes([]);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("RuleTypeRules handleChange:", name, value);

    const updatedRuleData = {
      ...ruleData,
      [name]: value,
    };

    setRuleData(updatedRuleData);

    if (props.onRuleDataChange) {
      props.onRuleDataChange(updatedRuleData);
    }
  };

  const renderCommonFields = () => {
    return (
      <>
        <Grid item xs={6}>
          <TextField
            name="rewardAmount"
            label="Reward Amount"
            type="number"
            fullWidth
            value={ruleData.rewardAmount}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel id="reward-type-select-label">Reward Type</InputLabel>
            <Select
              labelId="reward-type-label"
              id="reward-type-select"
              name="rewardType"
              value={ruleData.rewardType}
              label="Reward Type"
              onChange={handleChange}
            >
              <MenuItem value="coins">Coins</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </>
    );
  };

  const renderRuleSpecificFields = () => {
    switch (props.ruleType) {
      case 0:
        return (
          <Grid item xs={12}>
            <TextField
              name="minSpending"
              label="Minimum Spending"
              type="number"
              fullWidth
              value={ruleData.minSpending}
              onChange={handleChange}
            />
          </Grid>
        );
      case 1:
        return (
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="marketplace-item-select-label">
                Marketplace Item
              </InputLabel>
              <Select
                labelId="marketplace-item-label"
                id="marketplace-item-select"
                name="marketplaceItemId"
                value={ruleData.marketplaceItemId}
                label="Marketplace Item"
                onChange={handleChange}
              >
                {storeItems.map((item) => (
                  <MenuItem
                    key={item.marketplaceStoreItemId}
                    value={item.marketplaceStoreItemId}
                  >
                    {item.store === 1 ? "Google" : "Apple "} -{item.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        );
      case 2:
        return (
          <Grid item xs={12}>
            <TextField
              name="requiredDays"
              label="Required Days"
              type="number"
              fullWidth
              value={ruleData.requiredDays}
              onChange={handleChange}
            />
          </Grid>
        );
      case 3:
        return (
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="pack-types-select-label">Pack Types</InputLabel>
              <Select
                labelId="pack-types-label"
                id="pack-types-select"
                name="packTypes"
                value={ruleData.packTypes}
                label="Pack Types"
                onChange={handleChange}
                multiple
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => {
                      const packType = packTypes.find(
                        (pt) => pt.name === value
                      );
                      const displayName = packType
                        ? packType.name
                        : `Pack Type ${value}`;
                      return (
                        <Chip key={value} label={displayName} size="small" />
                      );
                    })}
                  </Box>
                )}
              >
                {packTypes.map((packType) => (
                  <MenuItem key={packType.name} value={packType.name}>
                    {packType.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        );
      case 4:
        return null; // Division Promotion has no additional fields
      default:
        return null;
    }
  };

  if (props.ruleType === undefined || props.ruleType === null) {
    return (
      <Grid container>
        <TextField label="Select a rule type first" fullWidth disabled />
      </Grid>
    );
  }

  return (
    <Grid container spacing={1}>
      {renderCommonFields()}
      {renderRuleSpecificFields()}
    </Grid>
  );
}
